import React, { useEffect, useState } from "react";
import scenariomodelbanner from "../../../main/assets/images/Images/Scenario Modelling-Icons/scenario-modelling-banner.png";
import scenario_banner_1 from "../../../main/assets/images/Images/Scenario Modelling-Icons/scenario_banner_1.png";
import sm_graph_1 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph_1.png";
import sm_graph_2 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph_2.png";
import sm_graph_3 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph_3.png";
import sm_graph_4 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph_4.png";
import sm_graph1 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph1.png";
import sm_graph2 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph2.png";
import sm_graph3 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph3.png";
import sm_graph4 from "../../../main/assets/images/Images/Scenario Modelling-Icons/sm_graph4.png";
import competitiveEdge from "../../../main/assets/images/Icons/Scenario Modelling-Icons/competitive-edge.svg";
import competitiveEdge1 from "../../../main/assets/images/Icons/Scenario Modelling-Icons/competitive-edge1.svg";
import proactiveDecision from "../../../main/assets/images/Icons/Scenario Modelling-Icons/proactive-decision-making.svg";
import proactiveDecision1 from "../../../main/assets/images/Icons/Scenario Modelling-Icons/proactive-decision.svg";
import riskReduction from "../../../main/assets/images/Icons/Scenario Modelling-Icons/risk-reduction.svg";
import riskReduction1 from "../../../main/assets/images/Icons/Scenario Modelling-Icons/risk-reduction1.svg";
import { Col } from "react-bootstrap";
import GraphDataOnLeft from "../../../main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "../../../main/components/componentsHelper/platformspage/GraphDataOnRight";
import PlatformLearnMore from "main/components/componentsHelper/platformspage/PlatformLearnMore";
import { SectionCard } from "main/components";
import HeadingParagrap from "main/components/componentsHelper/platformspage/HeadingParagrap";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
import PlatformModulesBanner from "main/components/componentsHelper/platformspage/PlatformModulesBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";
type Props = {};

const ScenarioModeling = (props: Props) => {
  interface CARDDATA {
    path: string;
    whiteIcon: string;
    title: string;
    textmsg: string;
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activetIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    setActiveIndex(index);
  };
  const carddata: CARDDATA[] = [
    {
      path: proactiveDecision,
      whiteIcon: proactiveDecision1,
      title: "Proactive Decision Making",
      textmsg:
        "Armed with insights from various scenarios, make decisions that are informed, timely, and forward-thinking.",
    },
    {
      path: riskReduction,
      whiteIcon: riskReduction1,
      title: "Risk Reduction",
      textmsg:
        "Avoid overexertion and misallocation of resources, resulting in significant cost benefits.",
    },
    {
      path: competitiveEdge,
      whiteIcon: competitiveEdge1,
      title: "Competitive Edge",
      textmsg:
        "Stay a step ahead of competitors by understanding potential future market dynamics and adapting swiftly.",
    },
  ];
  return (
    <div>
      <PlatformModulesBanner
        graphImage={sm_graph1}
        MobilebgImage={scenario_banner_1}
        mobilepraphImage={sm_graph_1}
        descriptionClass="text-white-color fonts-400 font-20 mb-20 font-family-roboto plat-desc"
        HeaderClassName="text-white-color fonts-300 font-40 mb-10 font-family-condensed plat-header"
        backgroundImage={scenariomodelbanner}
        heading="Scenario Modelling"
        description="Enable the planners with the power of foresight with Yantr.ai"
        buttonGroup={
          <>
            <div className="d-block d-md-none">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                  className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
            <div className="d-none d-md-block">
              <Link to={"/contact-us"}>
                <Button
                  textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                  className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                  text="Book a Demo"
                />
              </Link>
            </div>
          </>
        }
      />

      <HeadingParagrap
        heading="Scenario Modelling"
        headingpara="Harness our advanced algorithms to simulate potential future outcomes, enabling your business to prepare, adapt, and strategize for any eventuality."
      />
      {/* website */}
      <div className="py-60 bg-color-n d-none d-md-block justify-content-center align-items-center">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pb-60 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-30 container justify-content-center align-items-center">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sm_graph2}
            heading="Dynamic Simulation Capabilities"
            paragraph="Input varying factors and conditions to visualize different future outcomes, from best-case to worst-case scenarios."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={sm_graph3}
            heading="Customizable Factors"
            paragraph="Tailor your models by incorporating specific factors pertinent to your industry or business, whether economic conditions, technological innovations, or regulatory changes."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sm_graph4}
            heading="Risk Assessment"
            paragraph="Identify potential risks and challenges within each scenario, allowing for proactive planning and mitigation."
          />
        </div>
      </div>
      {/* Mobile View */}
      <div className="pb-30 bg-color-n d-block  d-md-none justify-content-center align-items-center">
        <div className="d-flex text-white-color font-family-roboto font-30 flex-gap-20 fonts-800 line-35 pt-40 pb-10 justify-content-center align-items-center garph-heading">
          Key Capabilities
        </div>
        <div className="d-flex flex-column flex-gap-20 py-30 container graphcontainer justify-content-center align-items-center">
          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sm_graph_2}
            heading="Dynamic Simulation Capabilities"
            paragraph="Input varying factors and conditions to visualize different future outcomes, from best-case to worst-case scenarios."
          />
          <GraphDataOnRight
            headingClass="text-black-10"
            path={sm_graph_3}
            heading="Customizable Factors"
            paragraph="Tailor your models by incorporating specific factors pertinent to your industry or business, whether economic conditions, technological innovations, or regulatory changes."
          />

          <GraphDataOnLeft
            headingClass="text-black-10"
            path={sm_graph_4}
            heading="Risk Assessment"
            paragraph="Identify potential risks and challenges within each scenario, allowing for proactive planning and mitigation."
          />
        </div>
      </div>
      {/* mobile */}
      <div className="d-block  d-md-none">
        <div className="container-fluid">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mt-4 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row mx-1 mb-40 p-10">
            <Swiper
              slidesPerView={"auto"}
              spaceBetween={0}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
              className="mySwiper customSwiper"
            >
              {carddata.map((val, index) => (
                <SwiperSlide className="p-10">
                  <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                    <Col key={index}>
                      <SectionCardMobile
                        classname="cards"
                        title={val.title}
                        icon={val.path}
                        whiteIcon={val.whiteIcon}
                        desc={val.textmsg}
                      />
                    </Col>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
      {/* website */}
      <div className="d-none d-md-block pt-60 pb-30">
        <div className="container">
          <h2 className="dark-header font-30 font-family-roboto fonts-800 line-35 mb-20 d-flex justify-content-center align-items-center plat-header">
            Benefits
          </h2>
          <div className="row g-2 m-1 p-10">
            {carddata.map((item, index) => (
              <div className="col-md-6 col-sm-6 col-lg-4 p-10">
                <div
                  className={`scard-container d-flex flex-column py-20 radius-10 justify-content-center align-items-center border border-1`}
                  key={index}
                >
                  <div className="image-container">
                    <img
                      className="sfront-image mx-5 my-3 mt-4"
                      src={item?.path}
                      alt="background will be here"
                    />
                    <img
                      className="sback-image mx-5 mb-2"
                      src={item?.whiteIcon}
                      alt="background will be here"
                    />
                  </div>
                  <div className="card-body">
                    <p
                      className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-26 line-30 pb-2`}
                      style={{ color: "#3D1187" }}
                    >
                      {item?.title}
                    </p>
                    <p
                      className="px-3 tcard-desc text-center text-white-color fonts-400 font-16 line-20 font-family-roboto"
                      style={{ color: "#3D1187" }}
                    >
                      {item?.textmsg}
                    </p>
                  </div>
                </div>
                <div className="d-block d-md-none text-center">
                  <button
                    key={index}
                    className={
                      index === activetIndex
                        ? "active p-1"
                        : "banner-slider p-1"
                    }
                    onClick={() => goToSlide(index)}
                  ></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PlatformLearnMore />
    </div>
  );
};

export default ScenarioModeling;
